module.exports = __webpack_public_path__ + "static/media/gradientWall.bad7d925.png";